import React from 'react';
import Input from '../elements/Input';

const ClientDetails = ({ formData, handleChange }) => {
  return (
    <div>
      <h2 className="text-xl font-semibold mb-4 border-b pb-1 text-gray-800 dark:text-white">Client Details</h2>
      <div className="grid md:grid-cols-2 gap-6 my-6">
        <Input label="Surname" type="text" name="surname" value={formData.surname} onChange={handleChange} />
        <Input label="Forename" type="text" name="forename" value={formData.forename} onChange={handleChange} />
        <Input label="Title" type="text" name="title" value={formData.title} onChange={handleChange} />
        <Input label="Date of Birth" type="date" name="dob" value={formData.dob} onChange={handleChange} />
        <Input label="Marital Status / Stage" type="text" name="marital_status" value={formData.marital_status} onChange={handleChange} />
        <Input label="N.I. Number" type="text" name="ni_number" value={formData.ni_number} onChange={handleChange} />
        <Input label="Ethnic Origin" type="text" name="ethnic_origin" value={formData.ethnic_origin} onChange={handleChange} />
        <Input label="Disability" type="text" name="disability" value={formData.disability} onChange={handleChange} />
        <Input label="Immigration Status" type="text" name="immigration_status" value={formData.immigration_status} onChange={handleChange} />
      </div>
    </div>
  );
};

export default ClientDetails;